import { useTranslation } from 'react-i18next';
import { MarketplaceDetail } from '@anytag/graphql';
import { getRestApiUrl } from '@anytag/shared-utils';
import { useDownloadFile } from '@anytag/shared-hooks';
import { Button, Form } from '@anytag/shared-atoms';
import { TextSearchField } from '@anytag/shared-molecules';
import { MarketplaceJoinedInfluencersFilterFormKeys } from './schemaTypes';

export interface TemplateProps {
  onSubmit?: () => void;
  marketplaceId: MarketplaceDetail['id'];
}

export const Template = ({ onSubmit, marketplaceId }: TemplateProps) => {
  const { t } = useTranslation();
  const { downloading, handleDownloadFile } = useDownloadFile();

  return (
    <Form.Fields>
      <TextSearchField<MarketplaceJoinedInfluencersFilterFormKeys>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={t<string>('Search.keywords')}
      />

      <Form.Field className="flex-none">
        <Button
          variant="outline"
          loading={downloading}
          className="min-w-29"
          title={t('Button.Download')}
          prefixIcon={{ icon: 'download', size: '14px' }}
          onClick={() =>
            handleDownloadFile({
              extension: '.csv',
              filenamePrefix: 'joined_influencers',
              url: getRestApiUrl(`marketplace/${marketplaceId}/affiliate_joined_influencers/csv/`)
            })
          }
        />
      </Form.Field>
    </Form.Fields>
  );
};
